import React, { useState, useEffect } from "react";
import { withFormik } from "formik";
import { ButtonSizeOptions, FormikInputTypeAhead as InputTypeAhead } from "@loanbossinc/component-library";

import { BackButton, DealName, InputWrapper, StyledPrimaryButton, Title, StyledDeleteButton, BackDeleteWrapper } from "./styles";

const Step0 = props => {
  const {
    handleSubmit,
    history,
    location,
    match: { params: { dealId, reportId } },
    newReportConfig,
    setFieldValue,
    isEditing,
    setSelections,
    reportSelections,
    values
  } = props;

  const [canSubmitt, setCanSubmitt] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [deliverableOptions, setDeliverableOptions] = useState([]);

  useEffect(() => {
    if (newReportConfig && newReportConfig.length > 0 && ((reportSelections && reportSelections.selectedDealId) || dealId != "notSelected")) {
      const _dealId = reportSelections && reportSelections.selectedDealId ? reportSelections.selectedDealId : parseInt(dealId);
      setFieldValue("selectedDealId", _dealId);
      const selectedDeal = newReportConfig.filter(x => x.id === _dealId);
      const _loanOptions = selectedDeal && selectedDeal[0] && selectedDeal[0].loans.length > 0 ? selectedDeal[0].loans : [];
      if (_loanOptions.length === 1) {
        reportSelections.selectedLoanId = _loanOptions[0].id;
        setFieldValue("selectedLoanId", _loanOptions[0].id);
      }
      setLoanOptions(_loanOptions);
      if (reportSelections && reportSelections.selectedLoanId) {
        setFieldValue("selectedLoanId", reportSelections.selectedLoanId);
        const selectedLoan = _loanOptions.filter(x => x.id === reportSelections.selectedLoanId);
        const _deliverables = selectedLoan && selectedLoan[0] && selectedLoan[0].deliverables.length > 0 ? selectedLoan[0].deliverables : [];
        if (_deliverables.length === 1) {
          reportSelections.selectedDeliverableId = _deliverables[0].id;
          setFieldValue("selectedDeliverableId", _deliverables[0].id);
        }
        setDeliverableOptions(_deliverables);
        if (reportSelections && reportSelections.selectedDeliverableId) {
          setFieldValue("selectedDeliverableId", reportSelections.selectedDeliverableId);
          const selectedDeliverable = _deliverables.filter(x => x.id === reportSelections.selectedDeliverableId);
          setFieldValue("reportName", selectedDeliverable[0].rgName);
          setFieldValue("reportingStartDate", selectedDeliverable[0].reportingStartDate);
          setFieldValue("reportingEndDate", selectedDeliverable[0].reportingEndDate);
          setFieldValue("reportingFrequencyId", selectedDeliverable[0].reportingFrequencyId);
          setCanSubmitt(true);
        }
      }
    }
  }, [reportSelections, newReportConfig]);

  const handleGoBack = () => {
    console.log("handleGoBack", location.state?.from);
    const route = location.state?.from === "edit-report-hero-card" ?
      `/deal/${dealId}/lender-reports/${reportId}` : "/lenderReportingDashboard";
    history.push(route);
  };

  const onDealSelect = value => {
    const selectedDeal = newReportConfig.filter(x => x.id === value);
    const _loanOptions = selectedDeal && selectedDeal[0] && selectedDeal[0].loans.length > 0 ? selectedDeal[0].loans : [];
    setLoanOptions(_loanOptions);
    setFieldValue("selectedLoanId", null);

    setDeliverableOptions([]);
    setFieldValue("selectedDeliverableId", null);
    setFieldValue("reportingStartDate", null);
    setFieldValue("reportingEndDate", null);
    setFieldValue("reportingFrequencyId", null);
  };
  const onLoanSelect = value => {
    const selectedLoan = loanOptions.filter(x => x.id === value);

    const _deliverables = selectedLoan && selectedLoan[0] && selectedLoan[0].deliverables.length > 0 ? selectedLoan[0].deliverables : [];
    setDeliverableOptions(_deliverables);
    setFieldValue("selectedDeliverableId", null);
    setFieldValue("reportingStartDate", null);
    setFieldValue("reportingEndDate", null);
    setFieldValue("reportingFrequencyId", null);
  };
  const onDeliverableSelect = value => {
    const selectedDeliverable = deliverableOptions.filter(x => x.id === value);
    if (value) {
      setFieldValue("reportName", selectedDeliverable[0].rgName);
      setFieldValue("reportingStartDate", selectedDeliverable[0].reportingStartDate);
      setFieldValue("reportingEndDate", selectedDeliverable[0].reportingEndDate);
      setFieldValue("reportingFrequencyId", selectedDeliverable[0].reportingFrequencyId);
      setCanSubmitt(true);
    }
  };
  const handleDelete = () => {
    setSelections({ isDeleteDialogOpen: true });
  };
  const submit = () => {
    if (canSubmitt) {
      handleSubmit();
      if (values.selectedDealId) {
        const urlReportId = reportId ? reportId : "new";
        history.replace(`/deal/${values.selectedDealId}/lender-reports-setup/${urlReportId}`, { from: "undefined-5" });
      }
    }
  };

  return (
    <>
      <Title>Create a new lender report</Title>
      <DealName>Select a deal</DealName>

      <InputWrapper>
        <InputTypeAhead
          id="deal"
          name="selectedDealId"
          label="Deal Name"
          options={newReportConfig}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={e => onDealSelect(e)}
          variant="filled"
          className="input"
        />
      </InputWrapper>
      <InputWrapper>
        <InputTypeAhead
          id="loan"
          name="selectedLoanId"
          label="Loan Name"
          options={loanOptions}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={e => onLoanSelect(e)}
          variant="filled"
          className="input"
          disabled={loanOptions.length === 0}
        />
      </InputWrapper>
      <InputWrapper>
        <InputTypeAhead
          id="deliverable"
          name="selectedDeliverableId"
          label="Report Name"
          options={deliverableOptions}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={e => onDeliverableSelect(e)}
          variant="filled"
          className="input"
          disabled={deliverableOptions.length === 0}
        />
      </InputWrapper>
      <StyledPrimaryButton
        disabled={!canSubmitt}
        size={ButtonSizeOptions.lg}
        label="Customize report content"
        style={{ width: "100%" }}
        onClick={submit}
      />
      <BackDeleteWrapper>
        <BackButton
          id="back-button"
          label={location.state?.from === "edit-report-hero-card" ? "Report summary" : "All lender compliance reports"}
          iconName="arrow_forward"
          reverse
          alignRight={false}
          onClick={handleGoBack}
        />
        {isEditing && <StyledDeleteButton label="Discard report" onClick={handleDelete} />}
      </BackDeleteWrapper>
    </>
  );
};

export default withFormik({
  mapPropsToValues: ({ reportConfig }) => ({ ...reportConfig }),
  handleSubmit(values, { props, setSubmitting }) {
    const { wizardStepIncrement, setSelectedReportConfig } = props;

    setSelectedReportConfig({
      reportSelections: {
        selectedDealId: values.selectedDealId,
        selectedLoanId: values.selectedLoanId,
        selectedDeliverableId: values.selectedDeliverableId,
        reportName: values.reportName,
        reportingStartDate: values.reportingStartDate,
        reportingEndDate: values.reportingEndDate,
        reportingFrequencyId: values.reportingFrequencyId
      }
    });

    setSubmitting(false);
    wizardStepIncrement();
  }
})(Step0);
